import { Box, Container } from "@mui/material";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CustomLoader from "global/components/CustomLoader/CustomLoader";
import urls from "global/constants/UrlConstants";
import { useState } from "react";
import history from "utils/history";
import planBgImage from "assets/images/planBgImage.svg";
import OnboardingStep3 from "screens/Settings/MyPlan/PlanDetails/components/UpgardePlan/OnboardingStep3";
import { useTitle } from "utils/UseTitle";
import title from "global/constants/TitleConstants";

const DirectRegister = () => {
  useTitle(title.REGISTER);
  const redirectState = history.location.state as
    | { currentPlan?: any; user?: any }
    | undefined;
  const promise = loadStripe(urls.STRIPE_PUBLIC_KEY);
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <>
      <Box
        component="main"
        id="main-content"
        tabIndex={-1}
        sx={{
          backgroundImage: `url(${planBgImage})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          mt: "4%",
          outline: "none",
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Elements stripe={promise}>
            <OnboardingStep3
              selectedPlan={redirectState?.currentPlan!}
              setLoading={setLoading}
              cardData={[]}
              forOnboarding={true}
              user={redirectState?.user}
              isPlanAnnual={
                redirectState?.currentPlan!.validityInDays === 365 ||
                redirectState?.currentPlan!.validityInDays === 366
              }
            />
          </Elements>
        </Container>
        <CustomLoader isLoading={loading} />
      </Box>
    </>
  );
};

export default DirectRegister;
